import { useEffect, useRef } from 'react';
import Icon from '../generic/Icon';
import * as style from './MiniCartIcon.module.css';

export default function MiniCartIcon({ itemCount }: { itemCount: number | undefined }) {
    const prevCount = useRef(itemCount);
    const cartCountRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (itemCount && prevCount.current !== undefined) runAnimation(cartCountRef.current);
        prevCount.current = itemCount;
    }, [itemCount]);

    return (
        <div className={style.icon} aria-live="off" aria-hidden data-count={itemCount ?? 0} ref={cartCountRef}>
            <Icon className="icon-cart" />
        </div>
    );
}

function runAnimation(element: HTMLElement | null) {
    element?.animate(
        [
            // keyframes
            { transform: 'scale(1)' },
            { transform: 'scale(2)' },
            { transform: 'scale(1)' },
        ],
        {
            // timing options
            easing: 'ease-in-out',
            duration: 300,
            iterations: 1,
            pseudoElement: '::after',
        },
    );
}
